import { connect } from "react-redux";
import { withFormik } from "formik";
import moment from "moment";

import DealCancelForm from "./DealCancelForm";

const form = withFormik({
  displayName: "dealCancel",
  mapPropsToValues: () => ({
    cancelDate: moment().format("YYYY-MM-DD"),
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
})(DealCancelForm);

const mapStateToProps = ({ loading }) => ({
  loading: loading.deal,
});

export default connect(mapStateToProps)(form);
